<template>
  <div class="index">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-row>
              <el-col>
                <el-form
                  ref="formData"
                  :model="formData"
                  label-width="110px"
                  class="demo-ruleForm">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="规则名称">
                        <el-input v-model="formData.rule_name"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="所属国家" prop="country">
                        <el-select v-model="formData.sh_country" clearable placeholder="请选择" @change="changeCountry">
                          <el-option
                            v-for="item in ds.country"
                            :key="item.sh_country"
                            :label="item.title"
                            :value="item.sh_country"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="所属大学">
                        <jm-Search
                          clearable
                          v-model="formData"
                          get-value="sh_name"
                          get-type="sh_name_cn"
                          :get-other-value="['sh_name', 'sh_id']"
                          :getother-type="['sh_name_cn', 'sh_id']"
                          :is-doble="true"
                          :country-id="cms_country || 0"
                          get-url='/index/api_base/searchSchool'
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="学院/特殊专业">
                        <el-input v-model="formData.rule_remark"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="最低均分要求">
                        <el-input v-model="formData.min_result"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="基准均分要求">
                        <el-input v-model="formData.stand_result"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="相关国内院校">
                        <el-row>
                          <el-col :span="12">
                            <el-row>
                              <el-col class="addGSchool" :span="24">
                                <el-button type="success" @click="addGSchoolType('list211')">211院校</el-button>
                                <el-button type="success" @click="addGSchoolType('list985')">985院校</el-button>
                                <el-button type="success" @click="addGSchoolType('list0985')">非985院校</el-button>
                                <el-button type="success" @click="addGSchoolType('list0211')">非211院校</el-button>
                                <el-button type="success" @click="addGSchoolType('list000')">双非院校</el-button>
                              </el-col>
                              <el-col class="addGSchool" :span="24">
                                <jm-Search
                                  clearable
                                  v-model="schoolCN"
                                  get-value="name"
                                  get-type="sh_name_cn"
                                  country-id="0"
                                  get-url='/index/api_base/searchGSchool'
                                />&nbsp;
                                <el-button type="primary" @click="addGSchoolSingle">添加</el-button>
                              </el-col>
                              <el-col class="addGSchool" :span="24">
                                <el-input
                                  type="textarea"
                                  :rows="2"
                                  placeholder="批量录入时输入"
                                  v-model="textSchool"/>
                              </el-col>
                              <el-col class="addGSchool" :span="6">
                                <el-button type="success" @click="addGSchoolBatch">批量检验</el-button>
                              </el-col>
                              <el-col class="addGSchool" :span="8">
                                <el-button type="primary" @click="showGSchool">{{ gschoolLock?'展开':'收起' }}右侧院校</el-button>
                              </el-col>
                              <el-col class="addGSchool" :span="6">
                                <el-button type="danger" plain @click="removeAllGSchool">清空右侧院校</el-button>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="12">
                            <div :class="'gschool-box '+(!gschoolLock?'all':'')">
                              <div class="gschool" v-for="(item, index) in gschool" :key="index">
                                {{ item }}&nbsp;<i class="el-icon-error" @click="removeGSchool(item)"></i>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="$hasPermission([62, 173])">
                      <el-button type="primary" @click="submit">保存</el-button>
                      <el-button type="info" plain @click="back">取消</el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jmSearch } from '@/components/tool';

const crumbs = () => import('@/components/tool/crumbs.vue');

export default {
  data() {
    return {
      ds: {
        list211: [],
        list985: [],
        list0211: [],
        list0985: [],
        list000: [],
        listall: []
      },
      textSchool: '',
      schoolCN: {},
      gschool: [],
      cms_country: '',
      formData: {
        id: this.$route.params.id || 0,
        rule_name: '',
        sh_country: '',
        sh_id: 0,
        sh_name: '',
        min_result: '',
        stand_result: '',
        cn_sh_name: ''
      },
      originData: {},
      gschoolLock: true,
    };
  },
  computed: {
  },
  components: {
    'jm-crumbs': crumbs,
    jmSearch,
  },
  methods: {
    fetchDictData() {
      this.$http
        ._get({
          url: '/index/u_u_college_rule/searchDict'
        })
        .then(({ data }) => {
          this.ds = Object.assign({}, this.ds, data);
          data.school_cn.forEach((i) => {
            if (i.is211) {
              this.ds.list211.push(i.sh_name_cn);
            } else {
              this.ds.list0211.push(i.sh_name_cn);
            }
            if (i.is985) {
              this.ds.list985.push(i.sh_name_cn);
            } else {
              this.ds.list0985.push(i.sh_name_cn);
            }
            if (!i.is211 && !i.is985) {
              this.ds.list000.push(i.sh_name_cn);
            }
            this.ds.listall.push(i.sh_name_cn);
          });
        });
      this.originData = Object.assign({}, this.formData);
    },
    fetchData(id) {
      this.$http
        ._get({
          url: `/index/u_u_college_rule/show?id=${id}`
        })
        .then(({ data }) => {
          this.formData = Object.assign({}, this.formData, data);
          this.originData = Object.assign({}, this.formData);
          this.formData.cn_sh_name = this.formData.cn_sh_name.replace(/,$/, '');
          this.formData.cn_sh_name = this.formData.cn_sh_name.replace(/^,/, '');
          this.gschool = this.formData.cn_sh_name === '' ? [] : this.formData.cn_sh_name.split(',');
        });
    },
    addGSchoolType(type) {
      if (typeof this.ds[type] !== 'undefined') {
        this.addGSchool(this.ds[type]);
      }
    },
    addGSchoolSingle() {
      if (this.schoolCN && this.schoolCN.name) {
        this.addGSchool([this.schoolCN.name]);
      }
    },
    addGSchoolBatch() {
      if (this.textSchool !== '') {
        this.textSchool = this.textSchool.replace(/[\uff0c]/g, ',');
        let schoolList = this.textSchool.split(',');
        schoolList = this.addGSchool(schoolList);
        this.textSchool = schoolList.join(',');
      }
    },
    removeGSchool(shName = '') {
      console.log('remove:', shName);
      let index = this.gschool.indexOf(shName);
      if (index > -1) {
        this.gschool.splice(index, 1);
      }
    },
    removeAllGSchool() {
      this.gschool = [];
    },
    addGSchool(schoolList = []) {
      let result = [];
      console.log(schoolList);
      schoolList.forEach((i) => {
        if (this.ds.listall.indexOf(i) > -1) {
          if (this.gschool.indexOf(i) === -1) {
            this.gschool.push(i);
          }
        } else {
          result.push(i);
        }
      });
      return result;
    },
    back() {
      this.formData = Object.assign({}, this.originData);
      this.$message.success('恢复数据');
    },
    changeCountry() {
      this.ds.country.forEach((i) => {
        if (this.formData.sh_country === i.sh_country) {
          this.cms_country = i.cms_country;
        }
      });
    },
    submit() {
      this.formData.cn_sh_name = this.gschool.join(',');
      this.formData.cn_sh_name = this.formData.cn_sh_name !== '' ? `,${this.formData.cn_sh_name},` : '';
      console.log(this.formData);
      this.$http
        ._post({
          url: '/index/u_u_college_rule/edit',
          data: this.formData
        })
        .then(() => {
          this.$message.success('保存成功');
          setTimeout(() => {
            window.close();
          }, 500);
        });
    },
    showGSchool() {
      this.gschoolLock = !this.gschoolLock;
    }
  },
  mounted() {
    this.fetchDictData();
    if (this.formData.id) {
      this.fetchData(this.formData.id);
    }
  },
};
</script>

<style scoped>
.addGSchool {
  line-height: 50px;
  padding: 0 5px;
}
.gschool-box{
  height: 200px;
  overflow-x: auto;
}
.gschool-box.all{
  height: auto;
}
.gschool {
  display: inline-block;
  border: solid 1px #aaa;
  margin-right: 5px;
  padding: 0 5px;
  line-height: 30px;
}
.gschool:hover {
  background-color: #ecf5ff;
}
.gschool i{
  color: #409eff;
}
</style>
